import { Injectable } from '@angular/core';

export interface IRejectedEmail {
    index: number
    value: string
}

export interface IValidateResults {
    validEmails: Array<string>
    rejectedEmails: Array<IRejectedEmail>
}

@Injectable()
export class ValidateImportService {

    constructor() {
    }

    public validate(content: string): IValidateResults {
        const lines = content.replace(/\r/g, '').split('\n');
        const validEmails: Array<string> = []
        const rejectedEmails: Array<IRejectedEmail> = []
        lines.forEach((value, index) => {
            if (!this.ignore(value, index)) {
                if (this.validatLine(value)) {
                    validEmails.push(value)
                } else {
                    rejectedEmails.push({ index, value })
                }
            }
        })
        return { validEmails, rejectedEmails };
    }

    private ignore(value: string, index: number): boolean {
        // ignore column title and empty lines
        return ((index === 0 && value.trim().toLocaleLowerCase() === 'email') || value.trim().length == 0)
    }

    private validatLine(value: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/email/editor/validate.import.service.ts